import {
  Grid2 as Grid,
  Box,
  Stepper,
  Step,
  StepButton,
  Button,
  Stack,
} from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { ConditionalGrid } from "@shared/components";
import { AgreementAppFormProps } from "./types";
import { useAgreementAppForm } from "./controller";
import { Step1 } from "./Steps";
import { useParams } from "react-router";
import { ModalComplete } from "./Steps/Step1/modalComplete";
import React from "react";
import { Step2 } from "./Steps/Step2";
import { api } from "@api/api";
import { ModalSubmit } from "./Steps/Step2/modalSubmit";

export function AgreementAppForm({
  onSubmit,
  isSubmitting,
}: AgreementAppFormProps) {
  const { id } = useParams();
  const translate = useTranslate();

  const modalCreateRef: any = React.useRef<HTMLButtonElement>(null);
  const modalSubmitRef: any = React.useRef<HTMLButtonElement>(null);
  const {
    steps,
    activeStep,
    handleStep,
    handleSubmit,
    handleBack,
    isLastStep,
  } = useAgreementAppForm();

  const handleRebuild = async () => {
    modalCreateRef.current.open();
    await api.post(`/v1/agreement_app_admin/${id}/update/`);
  };

  const handleSendSubmit = async () => {
    modalCreateRef.current.open();
    await api.post(`/v1/agreement_app_admin/${id}/submit/`);
  };

  const renderStepContent = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <Step1 />;
      case 1:
        return <Step2 />;
      default:
        return null;
    }
  };

  const renderButton = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return (
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            {id && (
              <Button onClick={handleRebuild} variant="outlined">
                Enviar nova Build
              </Button>
            )}
            <Button
              variant="contained"
              onClick={() => handleSubmit(onSubmit)}
              color="primary"
              loading={isSubmitting}
            >
              {id ? "Salvar" : "Criar Aplicativo"}
            </Button>
          </Stack>
        );
      default:
        return (
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              disabled={activeStep === 0 || isSubmitting}
              onClick={handleBack}
              variant="outlined"
            >
              {translate("buttons.back")}
            </Button>
            <Button onClick={handleSendSubmit} variant="outlined">
              Enviar app para Submissão
            </Button>
            <Button
              variant="contained"
              onClick={() => handleSubmit(onSubmit)}
              color="primary"
              loading={isSubmitting}
              disabled={!activeStep}
            >
              Salvar
            </Button>
          </Stack>
        );
    }
  };

  return (
    <Box component="form" sx={{ display: "flex", flexDirection: "column" }}>
      <Grid container spacing={6}>
        <Grid size={{ xs: 12 }}>
          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepButton onClick={handleStep(index)} disabled={!id}>
                  {label}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Grid>
      </Grid>
      <Stack direction="column" mt="20px" spacing={2}>
        {steps.map((_, index) => (
          <ConditionalGrid key={index} isVisible={activeStep === index}>
            {renderStepContent(index)}
          </ConditionalGrid>
        ))}
        {steps.map((_, index) => (
          <ConditionalGrid key={index} isVisible={activeStep === index}>
            {renderButton(index)}
          </ConditionalGrid>
        ))}
      </Stack>

      <ModalComplete
        ref={modalCreateRef}
        onClose={() => {
          modalCreateRef.current.close();
        }}
        onConfirm={() => {
          handleStep(1)();
          modalCreateRef.current.close();
        }}
      />
      <ModalSubmit
        ref={modalSubmitRef}
        onClose={() => {
          modalSubmitRef.current.close();
        }}
        onConfirm={() => {
          modalSubmitRef.current.close();
        }}
      />
    </Box>
  );
}
